<template>
  <DoneNotification></DoneNotification>
  <RejectNotification></RejectNotification>
  <ConfirmationEmail></ConfirmationEmail>
  <InfoEndedTasks></InfoEndedTasks>
  <CheckLevelModal></CheckLevelModal>
</template>

<script setup>
import DoneNotification from "@/components/modals/notification/DoneNotification";
import RejectNotification from "@/components/modals/notification/RejectNotification";
import ConfirmationEmail from "@/components/modals/ConfirmationEmail";
import InfoEndedTasks from "@/components/modals/InfoEndedTasks";
import CheckLevelModal from "@/components/modals/check-level-modal/CheckLevelModal";
</script>
